module.exports = __webpack_public_path__ + "static/img/111.02555e92.png";